import imageIcon from "assets/images/Logo_forsale-s_white.svg"
import imageBackground from 'assets/images/defaultBackground.jpg';
import Welcome from "../../partials/Welcome"

export const AuthLayout = props => {
    const { children } = props

    const styleBG = {
        height: window.innerHeight + 1,
        backgroundPosition: "center center",
        backgroundImage: `url(${imageBackground})`
    }

    const styleLogo = {
        minHeight: window.innerHeight * 0.1,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "top center",
        backgroundImage: `url(${imageIcon})`
    }

    const styleInner = {
        backgroundPosition: "top center",
        backgroundImage: "linear-gradient(180deg, #190002 0%, #8A0018 66%)"
    }

    return (
        <div
            className={`flex flex-col flex items-center pt-16`} style={styleBG}>
            <div className={`w-1/2 h-full flex flex-col`}>
                <div className={`w-full h-full px-16 rounded-lg pt-8`} style={styleInner}>
                    <div className={`w-full h-full`}>
                        {children}
                        <div className={`w-full h-full pt-32`}>
                            <Welcome width={window.innerWidth * 0.75} />
                        </div>
                    </div>
                </div>
                <div className={`w-full h-1/4`} style={styleLogo}></div>
            </div>
        </div>
    )
}

export default AuthLayout
